import React from 'react';
import {Avatar, Tooltip} from 'antd';
import {sanitize} from "../../utils/html.utils";
import {userInitialBackgroundColor, userInitial} from "../../utils/string.utils";

const Comment = ({author, avatar, content, datetime}) => {
    const authorInitials = userInitial(author);

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: '32px 1fr',
                gap: 10,
                padding: '12px 0',
                borderBottom: '1px dashed #E4E7EE',
            }}
        >
            <Tooltip title={author}>
                <Avatar
                    src={avatar || undefined}
                    alt={author}
                    size={30}
                    style={{
                        backgroundColor: userInitialBackgroundColor(authorInitials),
                        color: '#fff',
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    {!avatar && authorInitials}
                </Avatar>
            </Tooltip>
            <div style={{minWidth: 0}}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 8,
                        alignItems: 'baseline',
                    }}
                >
                    <span style={{fontSize: 13, fontWeight: 500, color: '#0B1220'}}>
                        {author}
                    </span>
                    <span
                        style={{
                            fontSize: 11.5,
                            color: '#7A849A',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {datetime}
                    </span>
                </div>
                <div
                    style={{
                        fontSize: 13,
                        color: '#374152',
                        marginTop: 2,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{__html: sanitize(content)}}
                />
            </div>
        </div>
    );
};

export default Comment;
